import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MealEntryServingEditor from './MealEntryServingEditor.tsx';
import fetchWithAuth from '../../utils/fetchWithAuth.ts';

const SelectedRecipePreview = ({
  recipe,
  servings: initialServings,
  onClose,
  weekStartISO,
  dayIndex,
  // slotKey,
  onSaved,
}) => {
  const navigate = useNavigate();
  const [servings, setServings] = useState(initialServings || 1);
  const handleRemove = async () => {
    await fetchWithAuth(`/api/meal-plan/${recipe.id}`, { method: 'DELETE' });
    onSaved(); // refresh parent
    onClose(); // close sheet
  };

  useEffect(() => {
    setServings(initialServings || 1);
  }, [initialServings]);

  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setHasChanges(servings !== initialServings);
  }, [servings, initialServings]);

  const handleSave = async () => {
    try {
      // NEW: patch only this entry’s servings
      await fetchWithAuth(`/api/meal-plan/${recipe.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ servings }),
      });
      onSaved();
    } catch (err) {
      console.error('Failed to update recipe', err);
    }
  };

  return (
    <div className="bg-white space-y-4 max-h-[500px] overflow-y-auto relative mt-4">
      {/* Top Row: Image, Title, Description */}
      <div className="flex items-start gap-4">
        <img
          src={recipe.imageUrl}
          alt={recipe.title}
          className="w-28 h-28 object-cover rounded border shrink-0"
          onClick={() => {
              navigate(`/app/recipe/${recipe.recipeId}`);
            }
          }
        />
        <div className="flex flex-col justify-between h-28 flex-1 overflow-hidden">
          <div 
            className="line-clamp-2 text-lg font-semibold leading-snug"
            onClick={() => {
                navigate(`/app/recipe/${recipe.recipeId}`);
              }
            }
            >
            {recipe.title}
          </div>

          {recipe.description && (
            <div className="text-sm text-gray-600 text-ellipsis overflow-hidden">
              <div className="line-clamp-[3]">{recipe.description}</div>
            </div>
          )}
        </div>
      </div>

      {/* Tags */}
      {/* {Array.isArray(recipe.tags) && recipe.tags.length > 0 && (
        <RecipeTagList
          recipeTags={recipe.tags.map((name) => ({
            tag: { id: name, name, type: 'MANUAL' },
          }))}
          onePerCategory
          maxVisible={5}
          size="sm"
        />
      )} */}

      {/* Serving Editor + Save */}
      <MealEntryServingEditor
        servings={servings}
        setServings={setServings}
        onSave={handleSave}
        disabled={!hasChanges}
      />

      <button
        onClick={handleRemove}
        className="mt-4 w-full text-center text-red-600 font-medium pb-5"
      >
        Remove from Plan
      </button>
    </div>
  );
};

export default SelectedRecipePreview;
